var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMacSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
    fill: "#007E46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84794 11.1712V11.5625H6.46714V11.1712H9.84794ZM10.3582 10.519V10.9103H5.76546V10.519H10.3582ZM11.1875 9.80163V10.2582H5.12758V9.80163H11.1875ZM8.12564 5.5625C8.80769 6.0425 9.04567 6.7625 8.80769 8.2025C9.91129 7.55946 10.7638 7.66305 11.1875 8.23641C10.8503 8.9383 10.248 9.43817 9.21005 9.60598L8.12564 9.01902L6.97745 9.60598C5.97877 9.38782 5.22518 8.99761 5 8.23641C5.54406 7.72615 6.15943 7.50271 7.37981 8.2025C7.03388 6.72859 7.37981 6.0425 8.12564 5.5625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86 6.1975L4.99056 6.48224L5.2825 6.5279L5.07125 6.74954L5.12112 7.0625L4.86 6.91474L4.59888 7.0625L4.64875 6.74954L4.4375 6.5279L4.72944 6.48224L4.86 6.1975ZM10.9525 6.1975L11.0831 6.48224L11.375 6.5279L11.1637 6.74954L11.2136 7.0625L10.9525 6.91474L10.6914 7.0625L10.7412 6.74954L10.53 6.5279L10.8219 6.48224L10.9525 6.1975ZM5.78022 4.82708L6.04535 5.02582L6.33464 4.90434L6.2561 5.23609L6.46224 5.50752L6.14858 5.5138L5.98669 5.80304L5.87137 5.47517L5.56518 5.3825L5.80757 5.17358L5.78022 4.82708ZM9.96881 4.75877L9.94146 5.10527L10.1839 5.31419L9.87766 5.40686L9.76234 5.73473L9.60046 5.44549L9.2868 5.43921L9.49294 5.16778L9.4144 4.83603L9.70369 4.95751L9.96881 4.75877ZM7.90625 3.875L8.11142 4.32245L8.57018 4.3942L8.23822 4.74249L8.31658 5.23429L7.90625 5.00209L7.49592 5.23429L7.57428 4.74249L7.24232 4.3942L7.70108 4.32245L7.90625 3.875Z",
    fill: "#D8E100"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacSm);
export default __webpack_public_path__ + "static/media/MAC-SM.8aa219ee399be9e418b4118f01ad430a.svg";
export { ForwardRef as ReactComponent };